// The design's default size is also the smallest size at which the window still works without collapsing.
export const ASSISTANT_CHAT_WINDOW_MIN_WIDTH = 456;
export const ASSISTANT_CHAT_WINDOW_MIN_HEIGHT = 520;
export const ASSISTANT_CHAT_WINDOW_DEFAULT_WIDTH = ASSISTANT_CHAT_WINDOW_MIN_WIDTH;
export const ASSISTANT_CHAT_WINDOW_DEFAULT_HEIGHT = ASSISTANT_CHAT_WINDOW_MIN_HEIGHT;
